var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSecuritySafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9386 7.41289V4.48622C13.9386 3.93956 13.5253 3.31956 13.0119 3.11289L9.29859 1.59289C8.46526 1.25289 7.52526 1.25289 6.69193 1.59289L2.97859 3.11289C2.47193 3.31956 2.05859 3.93956 2.05859 4.48622V7.41289C2.05859 10.6729 4.42526 13.7262 7.65859 14.6196C7.87859 14.6796 8.11859 14.6796 8.33859 14.6196C11.5719 13.7262 13.9386 10.6729 13.9386 7.41289ZM8.49859 8.57956V10.3329C8.49859 10.6062 8.27193 10.8329 7.99859 10.8329C7.72526 10.8329 7.49859 10.6062 7.49859 10.3329V8.57956C6.82526 8.36622 6.33193 7.73956 6.33193 6.99956C6.33193 6.07956 7.07859 5.33289 7.99859 5.33289C8.91859 5.33289 9.66526 6.07956 9.66526 6.99956C9.66526 7.74622 9.17193 8.36622 8.49859 8.57956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecuritySafe);
export default __webpack_public_path__ + "static/media/ic-security-safe.4dbc471ad76b86dce26d3f15dae05cf3.svg";
export { ForwardRef as ReactComponent };